import React from "react";
import { IBasicInfoDetailData } from "../../BasicInfoSection";
import replaceLineBreaks from "component-library/src/components/Functional/helpers/replaceLineBreaks";

interface IBasicInfoDetailsProps {
  details: IBasicInfoDetailData[];
}

export const BasicInfoDetails: React.FC<
  React.PropsWithChildren<IBasicInfoDetailsProps>
> = ({ details }) => {
  return (
    <div className="c-paper-cv__basic-info-grid">
      {details.map((detail, index) => (
        <div
          className="c-paper-cv__basic-info-pair"
          key={detail.name.toString() + index}
        >
          <span className="c-paper-cv__basic-info-name">{detail.name}</span>
          <span className="c-paper-cv__basic-info-value">
            {detail.values.map((value, index) => (
              <div
                key={value + index}
                dangerouslySetInnerHTML={{
                  __html: replaceLineBreaks(value || ""),
                }}
              />
            ))}
          </span>
        </div>
      ))}
    </div>
  );
};
